import authFetch from 'src/fetch/fetch';
import { getQueryParams, makeRequest } from 'src/fetch/utils';

const getSafetyEmailAddressesPath = () => '/api/SafetyEmailAddresses';

export const getAllSafetyEmailAddresses = () => makeRequest(authFetch.get(`${getSafetyEmailAddressesPath()}`));

export const updateSafetyEmailAddressesByType = (notificationType, data) => makeRequest(authFetch.put(`${getSafetyEmailAddressesPath()}/${notificationType}`, data));

export const getSafetyEmailAddressesAudit = (notificationType, params) => makeRequest(authFetch.get(`${getSafetyEmailAddressesPath()}/${notificationType}/Audits${getQueryParams(params)}`));

export const getSafetyEmailAddressesAuditProperties = (id, params) => makeRequest(authFetch.get(`${getSafetyEmailAddressesPath()}/${id}/Audits/Properties${getQueryParams(params)}`));

export const getSafetyEmailAddressesAuditUsers = (id, params) => makeRequest(authFetch.get(`${getSafetyEmailAddressesPath()}/${id}/Audits/Users${getQueryParams(params)}`));